/**
 * @generated SignedSource<<fbd0e8145991c16ec0ea375c09386f88>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ToggleMenu$data = {
  readonly currentUser: {
    readonly permissions: {
      readonly allow: ReadonlyArray<string>;
      readonly deny: ReadonlyArray<string>;
    };
  };
  readonly " $fragmentSpreads": FragmentRefs<"urlParams_thirdPartyToggleDefaults">;
  readonly " $fragmentType": "ToggleMenu";
};
export type ToggleMenu$key = {
  readonly " $data"?: ToggleMenu$data;
  readonly " $fragmentSpreads": FragmentRefs<"ToggleMenu">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ToggleMenu",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "currentUser",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Permissions",
          "kind": "LinkedField",
          "name": "permissions",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "allow",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "deny",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "urlParams_thirdPartyToggleDefaults"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "4ba90dd9fc3add722901c807745dd4ac";

export default node;
